import { IPagination } from 'app/types/common';

export interface IForfeitsState {
  readonly forfeitsById?: any;
  readonly forfeitIds?: string[];
  readonly hasLoaded?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasSaved?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly selectForfeitLoading?: boolean;
  readonly hasLoaded?: boolean;
  readonly showAddForfeit?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationForfeitIds?: string[];
  readonly currentForfeitId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IForfeitsSelector extends IForfeitsState {
  readonly currentForfeit?: any;
  readonly currentFormForfeit?: any;
  readonly getForfeitsFilteredByTagInSelectFormat?: any;
  readonly forfeitsByIdInSelectFormat?: any;
}

export enum ForfeitsActionTypes {
  GET_ALL_FORFEITS_REQUESTED = 'redux-app/forfeits/GET_ALL_FORFEITS_REQUESTED',
  GET_ALL_FORFEITS_PENDING = 'redux-app/forfeits/GET_ALL_FORFEITS_PENDING',
  GET_ALL_FORFEITS_SUCCESS = 'redux-app/forfeits/GET_ALL_FORFEITS_SUCCESS',
  GET_ALL_FORFEITS_FAIL = 'redux-app/forfeits/GET_ALL_FORFEITS_FAIL',
  GET_FORFEIT_REQUESTED = 'redux-app/forfeits/GET_FORFEIT_REQUESTED',
  GET_FORFEIT_PENDING = 'redux-app/forfeits/GET_FORFEIT_PENDING',
  GET_FORFEIT_SUCCESS = 'redux-app/forfeits/GET_FORFEIT_SUCCESS',
  GET_FORFEIT_FAIL = 'redux-app/forfeits/GET_FORFEIT_FAIL',
  UPDATE_FORFEIT_REQUESTED = 'redux-app/forfeits/UPDATE_FORFEIT_REQUESTED',
  UPDATE_FORFEIT_PENDING = 'redux-app/forfeits/UPDATE_FORFEIT_PENDING',
  UPDATE_FORFEIT_SUCCESS = 'redux-app/forfeits/UPDATE_FORFEIT_SUCCESS',
  UPDATE_FORFEIT_FAIL = 'redux-app/forfeits/UPDATE_FORFEIT_FAIL',
  CREATE_FORFEIT_REQUESTED = 'redux-app/forfeits/CREATE_FORFEIT_REQUESTED',
  CREATE_FORFEIT_PENDING = 'redux-app/forfeits/CREATE_FORFEIT_PENDING',
  CREATE_FORFEIT_SUCCESS = 'redux-app/forfeits/CREATE_FORFEIT_SUCCESS',
  CREATE_FORFEIT_FAIL = 'redux-app/forfeits/CREATE_FORFEIT_FAIL',
  DELETE_FORFEIT_REQUESTED = 'redux-app/forfeits/DELETE_FORFEIT_REQUESTED',
  DELETE_FORFEIT_PENDING = 'redux-app/forfeits/DELETE_FORFEIT_PENDING',
  DELETE_FORFEIT_SUCCESS = 'redux-app/forfeits/DELETE_FORFEIT_SUCCESS',
  DELETE_FORFEIT_FAIL = 'redux-app/forfeits/DELETE_FORFEIT_FAIL',
  SELECT_FORFEIT_REQUESTED = 'redux-app/forfeits/SELECT_FORFEIT_REQUESTED',
}

export default null;
